module.exports = __webpack_public_path__ + "assets/open-url.b65e097d.svg";